<!-- header -->
<app-header></app-header>

<!-- full outlet -->
<section class="content">
    <router-outlet></router-outlet>
</section>

<!-- footer -->
<app-footer></app-footer>

<!-- Custom Notification Controller -->
<toast-notification></toast-notification>
